// API 기본 URL 설정
const getApiBaseUrl = () => {
  // 환경변수가 있으면 우선 사용
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // 배포 환경 감지
  if (process.env.NODE_ENV === 'production') {
    return 'https://bapfriend.com';
  }
  
  // 개발 환경 기본값
  return 'http://localhost:8080';
};

const getWebSocketBaseUrl = () => {
  // 환경변수가 있으면 우선 사용
  if (process.env.REACT_APP_WS_BASE_URL) {
    return process.env.REACT_APP_WS_BASE_URL;
  }
  
  // 배포 환경 감지
  if (process.env.NODE_ENV === 'production') {
    return 'https://bapfriend.com/ws';
  }
  
  // 개발 환경 기본값
  return 'http://localhost:8080/ws';
};

export const API_BASE_URL = getApiBaseUrl();
export const WS_BASE_URL = getWebSocketBaseUrl();